module.exports = __webpack_public_path__ + "img/lightBCG.f4fd52f4.png";